/**
 * Matrice de jugement pour `MisereDecision` (MVP2.6 Gap 3).
 *
 * Fichier séparé du composant React pour respecter
 * `react-refresh/only-export-components`.
 */

export type MisereVerdict =
  | 'correct_positive' // tactique présente, Léon dit tactique
  | 'correct_negative' // pas de tactique, Léon dit calme
  | 'false_positive'   // pas de tactique, Léon dit tactique (sur-confiance)
  | 'false_negative';  // tactique présente, Léon dit calme (cécité)

/**
 * Calcule le verdict à partir de l'état "réel" (`hasTactic`) et de
 * la décision de Léon (`userSaysTactic`). Fonction pure, déterministe.
 */
export function computeVerdict(
  hasTactic: boolean,
  userSaysTactic: boolean,
): MisereVerdict {
  if (hasTactic && userSaysTactic) return 'correct_positive';
  if (hasTactic && !userSaysTactic) return 'false_negative';
  if (!hasTactic && userSaysTactic) return 'false_positive';
  return 'correct_negative';
}
